// import * as ROLES from './roles';

const authenticatedUserCondition = (authUser) => !!authUser;

export { authenticatedUserCondition };
